import { EstateLogFilter, EstateLogType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import useAppSelector from "@/core/helpers/useAppSelector.ts";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { estateSelector } from "@/domains/estate/slice.ts";
import toast from "@/domains/toasts/helpers/toast.ts";

export default () => {
  const estate = useAppSelector(estateSelector);
  const { t } = useTranslation("estate");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filter, setFilter] = useState<EstateLogFilter>(EstateLogFilter.All);
  const [logs, setLogs] = useState<
    {
      id: number;
      entityType: EstateLogType;
      entityId: number | null;
      baseCharacter: {
        characterId: number;
        name: string;
      } | null;
      targetCharacter: {
        characterId: number;
        name: string;
      } | null;
      amount: number | null;
      quantity: number | null;
      payload: unknown;
      createdAt?: string;
    }[]
  >([]);

  const load = useCallback(async () => {
    if (!estate) {
      return;
    }

    if (loading) {
      return;
    }

    setLoading(true);

    const response = await EstateMpProvider.getLogs(estate.id, page, filter);

    if (response instanceof RpcMpProviderFailedResponse) {
      toast.error(t("estate.errors.ERROR_LOAD_LOGS"));
      return;
    }

    if (page === 1) {
      setLogs(response.data.items);
    } else {
      setLogs((prev) => [...prev, ...response.data.items]);
    }
    setLoading(false);
    setTotalPages(response.data.totalPages);
  }, [t, estate, page, filter, loading]);

  useEffect(() => {
    setLogs([]);
    if (page !== 1) {
      setPage(1);
    }
  }, [filter]);

  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      load();
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [page, filter]);

  return {
    logs,
    loading,
    filter,
    setFilter,
    page,
    setPage,
    totalPages,
  };
};
